import { times } from "lodash-es";

import { Summary } from "src/base-components/Summary";
import { useCaseQueueSummary } from "src/cases/queries/queues";
import { Skeleton } from "src/design-system/Skeleton";
import { useEnvironment } from "src/hooks/useEnvironment";
import { CasesPageParams } from "src/router/urls";
import { useCurrentUserId } from "src/store/AuthStore";
import { useParamsDecode } from "src/utils/useParamsDecode";

const CaseQueueSummarySkeleton: React.FC = () => (
  <div className="flex min-w-0 flex-1 flex-col gap-y-1 px-5 py-4">
    <Skeleton height="h-5.5" width="w-10" />
    <Skeleton height="h-5.5" width="w-50" />
  </div>
);

export const CaseQueueSummary: React.FC = () => {
  const { queue_id: queueId } = useParamsDecode<CasesPageParams>();
  const [environment] = useEnvironment();
  const userId = useCurrentUserId();

  const { data: summary, isLoading } = useCaseQueueSummary({
    queueId,
    environment,
    userId,
  });

  return (
    <Summary dataLoc="case-queue-summary" variant="simple">
      {isLoading ? (
        times(3, (i) => <CaseQueueSummarySkeleton key={i} />)
      ) : (
        <>
          <Summary.Cell
            dataLoc="case-queue-summary-cell-total"
            title="Total number of cases"
            value={summary?.attributes.total ?? 0}
          />
          <Summary.Cell
            dataLoc="case-queue-summary-cell-unassigned"
            title="Unassigned"
            value={summary?.attributes.unassigned ?? 0}
          />
          <Summary.Cell
            dataLoc="case-queue-summary-cell-assigned-to-me"
            title="Assigned to me"
            value={summary?.attributes.assigned_to_user ?? 0}
          />
        </>
      )}
    </Summary>
  );
};
